/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./spinner.component.scss.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./spinner.component";
var styles_UISpinnerComponent = [i0.styles];
var RenderType_UISpinnerComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_UISpinnerComponent, data: {} });
export { RenderType_UISpinnerComponent as RenderType_UISpinnerComponent };
export function View_UISpinnerComponent_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 0, "div", [], null, null, null, null, null)), (_l()(), i1.ɵeld(1, 0, null, null, 0, "div", [], null, null, null, null, null)), (_l()(), i1.ɵeld(2, 0, null, null, 0, "div", [], null, null, null, null, null))], null, null); }
export function View_UISpinnerComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "ui-spinner", [], null, null, null, View_UISpinnerComponent_0, RenderType_UISpinnerComponent)), i1.ɵdid(1, 49152, null, 0, i2.UISpinnerComponent, [], null, null)], null, null); }
var UISpinnerComponentNgFactory = i1.ɵccf("ui-spinner", i2.UISpinnerComponent, View_UISpinnerComponent_Host_0, {}, {}, []);
export { UISpinnerComponentNgFactory as UISpinnerComponentNgFactory };
